export default __webpack_public_path__ + "static/media/contact-seamless-header.a2d1f0c1.svg";